const selfie = () => (
    <section>
        <div className="profile">
            <div className="profile_shape profile_image">
                <div className='profile_caption'>
                    <h3 className='profile_caption__small'>Hi, I&apos;m</h3>
                    <h1 className='profile_caption__large'>Matt Cole</h1>
                    <p className='profile_caption__small'>Engineer</p>
                    <p className='profile_caption__small'>Developer</p>
                    <p className='profile_caption__small'>Change Maker</p>
                </div>
            </div>
        </div>
    </section>
);

export default selfie;